import * as z from "zod/v4";

const OutputPlacementSchema_ = z.object({
  productId: z.string(),
  storageLocationId: z.string(),
  quantity: z.number(),
});
export const OutputPlacementSchema: z.ZodType<OutputPlacement> =
  OutputPlacementSchema_;
export interface OutputPlacement
  extends z.infer<typeof OutputPlacementSchema_> {}

export const advanceWorkOrder = {
  name: "advanceWorkOrder" as const,
  input: z.object({
    workOrderId: z.string(),
    outputPlacements: z.array(OutputPlacementSchema).nullish(),
    fromStepId: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
